// ---------------------------------------------------------------------------
// Cobranças — leitura relativa da data de vencimento (linha da listagem).
//
// Datas de vencimento vêm do backend como 'YYYY-MM-DD' (date-only). Todo o
// cálculo aqui é feito em cima da string / de datas locais ao meio-dia, para
// não escorregar um dia por fuso — o clássico `new Date('2026-08-10')` que é
// meia-noite UTC e vira 09/08 no Brasil.
//
// Os presets de vencimento (Todos/Vencidos/Hoje/Próximos 30 dias/Este mês) e
// seus helpers saíram em 2026-09-02, junto com o grupo de chips da tela — o
// filtro de vencimento agora é só o range De/Até.
// ---------------------------------------------------------------------------

function todayLocal() {
   const now = new Date();
   return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
}

// Diferença em dias inteiros entre hoje e a data (positivo = futuro).
function daysFromToday(isoDate) {
   if (!isoDate) return null;
   const [y, m, d] = String(isoDate).substring(0, 10).split('-').map(Number);
   if (!y || !m || !d) return null;
   const target = new Date(y, m - 1, d, 12);
   const diffMs = target.getTime() - todayLocal().getTime();
   return Math.round(diffMs / 86400000);
}

export function isOverdue(isoDate, status) {
   if (status !== 'PENDING' && status !== 'OVERDUE') return false;
   const diff = daysFromToday(isoDate);
   return diff !== null && diff < 0;
}

// Leitura relativa do vencimento. Só faz sentido para título em aberto: um
// boleto pago mês passado não precisa de "venceu há 30 dias", precisa da data.
export function relativeDueLabel(isoDate, status) {
   const isOpen = status === 'PENDING' || status === 'OVERDUE';
   if (!isOpen) {
      const [y, m, d] = String(isoDate ?? '').substring(0, 10).split('-');
      return y ? `venc. ${d}/${m}` : '—';
   }

   const diff = daysFromToday(isoDate);
   if (diff === null) return '—';
   if (diff < 0) {
      const n = Math.abs(diff);
      return `venceu há ${n} ${n === 1 ? 'dia' : 'dias'}`;
   }
   if (diff === 0) return 'vence hoje';
   if (diff === 1) return 'vence amanhã';
   return `em ${diff} dias`;
}

// Partes do bloco de data da linha (dia / mês abreviado / ano).
export function dateParts(isoDate) {
   const raw = String(isoDate ?? '').substring(0, 10);
   const [y, m, d] = raw.split('-');
   if (!y || !m || !d) return { day: '--', month: '---', year: '----' };

   const month = new Date(Number(y), Number(m) - 1, 1, 12)
      .toLocaleDateString('pt-BR', { month: 'short' })
      .replace('.', '')
      .toUpperCase();

   return { day: d, month, year: y };
}
